import React from 'react';
import Text from './base';

const H4 = props => <Text tag="h4" variant="h4" {...props} />;

export default H4;
